module.exports = __webpack_public_path__ + "img/production_banner.9b457e33.jpg";